import * as $runtime from "../runtime.js";
import * as Data$dArray from "../Data.Array/index.js";
import * as Data$dFoldable from "../Data.Foldable/index.js";
import * as Data$dFoldableWithIndex from "../Data.FoldableWithIndex/index.js";
import * as Data$dInt from "../Data.Int/index.js";
import * as Data$dMaybe from "../Data.Maybe/index.js";
import * as Data$dShow from "../Data.Show/index.js";
import * as Effect from "../Effect/index.js";
import * as Specular$dDom$dBuilder$dClass from "../Specular.Dom.Builder.Class/index.js";
import * as Specular$dDom$dWidgets$dInput from "../Specular.Dom.Widgets.Input/index.js";
import * as Specular$dFRP$dBase from "../Specular.FRP.Base/index.js";
import * as Specular$dFRP$dWeakDynamic from "../Specular.FRP.WeakDynamic/index.js";
const for_ = /* #__PURE__ */ Data$dFoldable.for_(Effect.applicativeEffect)(Data$dFoldable.foldableMaybe);
const selectView = dictMonadWidget => {
  const MonadDomBuilder0 = dictMonadWidget.MonadDomBuilder0();
  const MonadCleanup1 = dictMonadWidget.MonadReplace2().MonadCleanup1();
  const Monad0 = MonadCleanup1.Monad0();
  const Bind1 = Monad0.Bind1();
  const elDynAttr$p = MonadDomBuilder0["elDynAttrNS'"](Data$dMaybe.Nothing);
  const Applicative0 = Monad0.Applicative0();
  const traverseWithIndex_ = Data$dFoldableWithIndex.traverseWithIndex_(Applicative0)(Data$dFoldableWithIndex.foldableWithIndexArray);
  const $0 = dictMonadWidget.MonadFRP1().MonadEffect0();
  const monadFRP = {MonadEffect0: () => $0, MonadCleanup1: () => MonadCleanup1};
  const subscribeDyn_ = Specular$dFRP$dBase.subscribeDyn_(monadFRP);
  const domEventWithSample = Specular$dDom$dBuilder$dClass.domEventWithSample(monadFRP);
  return dictEq => config => valueD => Bind1.bind(elDynAttr$p("select")(config.attributes)(traverseWithIndex_(index => value => MonadDomBuilder0.elAttr("option")((() => {
    const $1 = Data$dShow.showIntImpl(index);
    return (() => {
      const $2 = {};
      $2.value = $1;
      return $2;
    })();
  })())(MonadDomBuilder0.text(config.display(value))))(config.options)))(v => {
    const $1 = v._1;
    return Bind1.bind(subscribeDyn_(Specular$dFRP$dWeakDynamic.traverse_(value => for_(Data$dArray.findIndexImpl(
      Data$dMaybe.Just,
      Data$dMaybe.Nothing,
      dictEq.eq(value),
      config.options
    ))(index => Specular$dDom$dWidgets$dInput.setTextInputValue($1)(Data$dShow.showIntImpl(index)))))(valueD))(() => Bind1.bind(domEventWithSample(v1 => Specular$dDom$dWidgets$dInput.getTextInputValue($1))("change")($1))(domChanged => Applicative0.pure(Specular$dFRP$dBase.filterMapEvent(a => {
      const $2 = Data$dInt.fromString(a);
      if ($2.tag === "Just") { return Data$dArray.indexImpl(Data$dMaybe.Just, Data$dMaybe.Nothing, config.options, $2._1); }
      if ($2.tag === "Nothing") { return Data$dMaybe.Nothing; }
      $runtime.fail();
    })(domChanged))));
  });
};
const selectInput = dictMonadWidget => {
  const MonadDomBuilder0 = dictMonadWidget.MonadDomBuilder0();
  const MonadCleanup1 = dictMonadWidget.MonadReplace2().MonadCleanup1();
  const Monad0 = MonadCleanup1.Monad0();
  const Bind1 = Monad0.Bind1();
  const elDynAttr$p = MonadDomBuilder0["elDynAttrNS'"](Data$dMaybe.Nothing);
  const traverseWithIndex_ = Data$dFoldableWithIndex.traverseWithIndex_(Monad0.Applicative0())(Data$dFoldableWithIndex.foldableWithIndexArray);
  const MonadEffect0 = dictMonadWidget.MonadFRP1().MonadEffect0();
  const monadFRP = {MonadEffect0: () => MonadEffect0, MonadCleanup1: () => MonadCleanup1};
  const domEventWithSample = Specular$dDom$dBuilder$dClass.domEventWithSample(monadFRP);
  const holdDyn = Specular$dFRP$dBase.foldDyn(monadFRP)(x => v => x);
  return config => Bind1.bind(elDynAttr$p("select")(config.attributes)(traverseWithIndex_(index => value => MonadDomBuilder0.elAttr("option")((() => {
    const $0 = Data$dShow.showIntImpl(index);
    return (() => {
      const $1 = {};
      $1.value = $0;
      return $1;
    })();
  })())(MonadDomBuilder0.text(config.display(value))))(config.options)))(v => {
    const $0 = v._1;
    return Bind1.bind(MonadEffect0.liftEffect(Specular$dDom$dWidgets$dInput.setTextInputValue($0)(Data$dShow.showIntImpl(config.initialValueIndex))))(() => Bind1.bind(domEventWithSample(v1 => Specular$dDom$dWidgets$dInput.getTextInputValue($0))("change")($0))(domChanged => holdDyn(Data$dArray.unsafeIndexImpl(
      config.options,
      config.initialValueIndex
    ))(Specular$dFRP$dBase.filterMapEvent(a => {
      const $1 = Data$dInt.fromString(a);
      if ($1.tag === "Just") { return Data$dArray.indexImpl(Data$dMaybe.Just, Data$dMaybe.Nothing, config.options, $1._1); }
      if ($1.tag === "Nothing") { return Data$dMaybe.Nothing; }
      $runtime.fail();
    })(domChanged))));
  });
};
export {for_, selectInput, selectView};
